import React from "react";
import styled from "styled-components";
import GateIoImg from "../../../../assets/gate.io.png";
import QuickSwapImg from "../../../../assets/quickswap.png";
import ProbitImg from "../../../../assets/probit.png";
import { ReactComponent as UniswapImg } from "../../../../assets/uniswap.svg";
import { Flex } from "../../../../components/layout";
import Tile from "./tile";
import { colours } from "../../../../styles/colours";
import { WIDGET_BORDER_RADIUS } from "../../../../components/widget";
import { device } from "../../../../styles/media";

interface IGetSkrtTileProps { }

const ImageWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  padding: 0.2em;

  @media ${device.tablet} {
    padding: 1em;
  }
`;

const StyledTile = styled(Tile)`
  font-size: 0.6em;
  padding: 1em;
`;

const SpacedFlex = styled(Flex)`
  justify-content: space-between;
  width: 100%;
  margin: 0 1em;

  @media ${device.tablet} {
    margin: 0 2em;
  }
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  text-align: center;
  border-radius: ${WIDGET_BORDER_RADIUS};
`;

const GetSkrtTitle = styled.p`
  text-transform: uppercase;
  color: ${colours.blue};
`;

const Image = styled.img`
object-fit: contain;
`;

const logoSize = 50;

const GetSkrtTile: React.FunctionComponent<IGetSkrtTileProps> = () => {
  return (
    <StyledTile>
      <SpacedFlex>
        <GetSkrtTitle>
          Get Some <strong>$SKRT</strong>
        </GetSkrtTitle>
        <Wrapper>
          <a
            href="https://app.uniswap.org/explore/tokens/ethereum/0x887168120cb89fb06f3e74dc4af20d67df0977f6"
            target="_blank"
            rel="noreferrer"
          >
            <ImageWrapper>
              <UniswapImg width={logoSize} height={logoSize} />
            </ImageWrapper>
          </a>
          <a
            href="https://quickswap.exchange/#/swap?inputCurrency=0xe51e88dd08499762b8e4eb3a9f3da9b8e79608c3&outputCurrency=0x2791bca1f2de4661ed88a30c99a7a9449aa84174&swapIndex=0"
            target="_blank"
            rel="noreferrer"
          >
            <ImageWrapper>
              <Image width={logoSize} height={logoSize} src={QuickSwapImg} />
            </ImageWrapper>
          </a>
          {/* <a
            href="https://www.gate.io/trade/SKRT_USDT"
            target="_blank"
            rel="noreferrer"
          >
            <ImageWrapper>
              <Image width={logoSize} height={logoSize} src={GateIoImg} />
            </ImageWrapper>
          </a> */}
          {/* <a
            href="https://www.probit.com/app/exchange/SKRT-ETH"
            target="_blank"
            rel="noreferrer"
          >
            <ImageWrapper>
              <Image width={logoSize} height={logoSize} src={ProbitImg} />
            </ImageWrapper>
          </a> */}
        </Wrapper>
      </SpacedFlex>
    </StyledTile>
  );
};

export default GetSkrtTile;
